import ngMaterial from 'angular-material';
import uiRouter from 'angular-ui-router';
import angularTranslate from 'angular-translate';

import gazelle from 'gazelle';
import rhino from 'rhino';
// import HP common style classes
import 'gazelle/src/style/hpprintos.scss';
import cacheImages from './cache-images.run';
import './start.scss';

// Import view controller names
import * as HpIdSignInController from './components/accept/hpid-sign-in/hpid-sign-in.controller';

// Pull in all component modules here.
// In the future, look to introduce webpack split points for performance
// in the router configuration.
// See https://github.com/ay13/webpack-angular-oclazyload/blob/master/app/config.js#L43
let appModuleNames = requireAllModules();

// Common state resolve functions
const resolve = {
  // Ensures translates are loaded
  loadTranslations,
};

angular.module('start',[
    ngMaterial,
    uiRouter,
    rhino,
    gazelle,
    angularTranslate,
  ].concat(appModuleNames)
)
  .config(configApp)
  .config(configRoutes)
  .config(configLocCatalogs)
  .run(cacheImages)
  .run(appRun);

function configApp($logProvider, rnDebugEnabled, rnClientProvider) {
  'ngInject';
  $logProvider.debugEnabled(rnDebugEnabled);

  // Don't use Blue for registry because this app doesn't load blue
  rnClientProvider.useBlueApi(false);
}

function configRoutes($stateProvider, $urlRouterProvider) {
  'ngInject';

  // For any unmatched url, redirect to /state1
  $urlRouterProvider.otherwise('/signin');

  // Now set up the states
  $stateProvider
    .state('signin', {
      url: '/signin?forward&messageKey&messageParams&statusCode&subCode&username&altUsername&userId&orgId&chooseAccount&bu',
      params: {
        signout: undefined,
        forward: undefined,
        messageKey: undefined,
        messageParams: undefined,
        statusCode: undefined,
        subCode: undefined,
        username: undefined,
        chooseAccount: undefined,
        data: undefined,
        userId: undefined,
        orgId: undefined,
        bu: undefined,
      },
      template: require('./components/sign-in/sign-in.jade'),
      controller: 'SignInController',
      controllerAs: 'vm',
      resolve,
    })
    .state('redirect', {
      url: '/redirect?bu',
      params: {
        data: undefined,
        bu: undefined,
      },
      template: require('./components/redirect/redirect.jade'),
      controller: 'RedirectController',
      controllerAs: 'vm',
      resolve,
    })
    .state('signup', {
      url: '/signup?bu',
      params: {
        data: undefined,
        bu: undefined,
      },
      template: require('./components/sign-up/sign-up.jade'),
      controller: 'SignUpController',
      controllerAs: 'vm',
      resolve,
    })
    .state('support', {
      url: '/support?bu&fromState',
      params: {
        data: undefined,
        bu: undefined,
        fromState: 'signin'
      },
      template: require('./components/support/support.jade'),
      controller: 'SupportRequestController',
      controllerAs: 'vm',
      resolve,
    })
    .state('account', {
      url: '/account?bu',
      params: {
        data: undefined,
        bu: undefined,
      },
      controller: 'SelfProvisionController',
      resolve,
    })
    .state('migration', {
      url: '/migration?bu',
      params: {
        data: undefined,
        bu: undefined,
      },
      controller: 'MigrateUserController',
      resolve,
    })
    .state('acceptHpIdSignIn', {
      url: '/accept/sign-in?state&invitationId&statusCode&subCode&hpidId&bu',
      params: {
        signout: undefined,
        invitationId: undefined,
        state: undefined,
        statusCode: undefined,
        subCode: undefined,
        hpidId: undefined,
        data: undefined,
        bu: undefined,
      },
      template: require('./components/accept/hpid-sign-in/hpid-sign-in.jade'),
      controller: HpIdSignInController.name,
      controllerAs: 'vm',
      resolve,
    })
    .state('acceptUser', {
      url: '/accept/user/{invitationId}?hpidId&bu',
      params: {
        data: undefined,
        hpidId: undefined,
        bu: undefined,
      },
      template: require('./components/accept/user/accept-user.jade'),
      controller: 'AcceptUserController',
      controllerAs: 'vm',
      resolve,
    })
    .state('acceptExistingUser', {
      url: '/accept/existing-user/{invitationId}?bu',
      params: {
        data: undefined,
        bu: undefined,
      },
      template: require('./components/accept/user/accept-existing-user.jade'),
      controller: 'AcceptExistingUserController',
      controllerAs: 'vm',
      resolve,
    })
    .state('acceptAccount', {
      url: '/accept/account/{invitationId}?hpidId&bu',
      params: {
        data: undefined,
        hpidId: undefined,
        bu: undefined,
      },
      template: require('./components/accept/account/accept-account.jade'),
      controller: 'AcceptAccountController',
      controllerAs: 'vm',
      resolve,
    })
    .state('lf-code', {
      //activate/lf/activationCode=
      url: '/activate/lf?bu',
      params: {
        data: undefined,
        bu: undefined,
      },
      template: require('./components/lf-code/lf-code.jade'),
      controller: 'addLFCodeController',
      controllerAs: 'vm',
      resolve,
    })
    .state('lf-add', {
      //activate/lf/activationCode=
      url: '/activate/lf/{lfCode}?bu',
      params: {
        data: undefined,
        bu: undefined,
      },
      template: require('./components/lf-add/lf-add.jade'),
      controller: 'addLFDeviceController',
      controllerAs: 'vm',
      resolve,
    })
    .state('unsubscribe', {
      url: '/unsubscribe?email&category&userId&bu',
      params: {
        data: undefined,
        bu: undefined,
      },
      template: require('./components/unsubscribe/unsubscribe.jade'),
      controller: 'UnsubscribeController',
      controllerAs: 'vm',
      resolve
    })
    .state('help', {
      url: '/help/{topicId}',
      params: {
        topicId: undefined,
      },
      template: require('./components/help/help-wrapper.jade'),
      controller: 'HelpWrapperController',
      controllerAs: 'vm',
      resolve
    });
}

function appRun() {
  //noinspection BadExpressionStatementJS
  'ngInject';

  console.log('Start App Running');
}

function configLocCatalogs($translateProvider) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  $translateProvider.useLoader('gzL10nLoader', {
    'catalogServices': {
      'register.register': 'portal_service',
      'devices.devices': 'portal_service'
    }
  });
}

function loadTranslations($translate) {
  'ngInject';
  return $translate.onReady();
}

/**
 * Require all component modules and return the module names.
 * (This uses webpack's require.context() function to find and
 * then require all module files.)
 *
 * @returns {string[]} module names
 */
function requireAllModules() {
  let requiresModule = require.context('./components', true, /\.module\.js$/);
  let scriptFiles = requiresModule.keys();
  return scriptFiles.map(script => requiresModule(script));
}



// WEBPACK FOOTER //
// ./start.module.js